import {defaultTheme} from '@stencil/build-theme';
import React, {useState} from 'react';
import GoStaysIcon from '../../../../../stories/Icons/GoStaysIcon';
import fallbackImage from '../../../../assets/fallback-image.png';
import GoStaysPromises from '../GoStaysPromises/GoStaysPromises';
import {ISRPHotelThumbnailImages} from '../../../../../shared/pages/SRP/redux/types';
import * as S from './HotelCardImageGallery.styles';

const HotelCardImageGallery = ({
  data,
  limit = 5,
  navigateToDetailsPage,
  country = '',
  isGoStays = false,
  gostaysPromises = [],
}: {
  data: Array<ISRPHotelThumbnailImages>;
  limit?: number;
  navigateToDetailsPage: Function;
  isGoStays: boolean;
  country: string;
  gostaysPromises?: Array<string>;
}) => {
  const [mainImage, setMainImage] = useState((data[0] && data[0]['mi']) || fallbackImage);
  const [showCustomBanner, setShowCustomBanner] = useState(false);

  let hasCarousel = false;

  if (data.length > 1) {
    hasCarousel = true;
  }

  const onClickHandler = () => {
    // navigateToDetailsPage();
  };

  return (
    <>
      {showCustomBanner ? (
        <GoStaysPromises
          promises={gostaysPromises}
          actionHandler={e => {
            e.stopPropagation();
            navigateToDetailsPage({tag: 'goStays'});
          }}
        />
      ) : mainImage ? (
        <>
          <meta itemProp="image" content={mainImage} />
          <S.ImageStyle src={mainImage} fallback={fallbackImage} onClick={onClickHandler} />
        </>
      ) : (
        <S.NoImageListIconWrap height="21rem" width="24.5rem" onClick={onClickHandler}>
          <S.ImageStyleFallbackLarge src={fallbackImage} />
        </S.NoImageListIconWrap>
      )}
      {(hasCarousel && (
        <S.ImageList>
          {(isGoStays && (
            <li
              onClick={onClickHandler}
              onMouseEnter={() => {
                setShowCustomBanner(true);
              }}
            >
              <S.GoStaysIconWrapperForImageListDiv>
                <S.GoStaysIconWrapperForImageListSpan>
                  <GoStaysIcon
                    height="3.2rem"
                    width="3.2rem"
                    fill={defaultTheme.colors.goBrandOrange.base}
                  />
                </S.GoStaysIconWrapperForImageListSpan>
              </S.GoStaysIconWrapperForImageListDiv>
            </li>
          )) ||
            null}
          {data &&
            data.map((item, index) => {
              if (index < (isGoStays ? limit - 1 : limit)) {
                return (
                  <li
                    key={`HotelCardImageGalleryItem_${index}`}
                    onMouseEnter={() => {
                      if (showCustomBanner) setShowCustomBanner(false);
                      setMainImage(item['mi']);
                    }}
                    onClick={onClickHandler}
                  >
                    <S.MiniImageStyle src={item['si']} fallback={fallbackImage} />
                  </li>
                );
              }
            })}
          <S.ViewAllWrapperStyle>
            <S.ViewAllTextStyle>View All</S.ViewAllTextStyle>
          </S.ViewAllWrapperStyle>
        </S.ImageList>
      )) || (
        <S.ImageList>
          {[...Array(5)].map(() => (
            <li onClick={onClickHandler}>
              <S.NoImageListIconWrap>
                <S.ImageStyleFallbackSmall src={fallbackImage} />
              </S.NoImageListIconWrap>
            </li>
          ))}
        </S.ImageList>
      )}
    </>
  );
};

export default HotelCardImageGallery;
